<template>
  <div>
    <el-row>
      <span
        ><h1>{{ headerTitel }}</h1></span
      >
    </el-row>
    <el-row style="text-align:center">
      <el-form
        :inline="true"
        class="demo-form-inline"
        label-position="right"
        label-width="100px"
        :model="searchForm"
      >
        <el-form-item label="选择站点:" prop="stationId">
          <el-select
            style="width: 85%"
            v-model="searchForm.stationId"
            placeholder="请选择"
            @change="stationIdChange"
          >
            <el-option
              v-for="item in stationIdOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:" label-width="300">
          <el-date-picker
            v-model="searchForm.startTime"
            clearable
            type="date"
            placeholder="开始时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <!-- <el-input placeholder="请输入手机号" clear width="180px" v-model="searcheForm.phone"></el-input> -->
        </el-form-item>
        <el-form-item label="结束日期:">
          <el-date-picker
            v-model="searchForm.endTime"
            clearable
            type="date"
            placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <!-- <el-input placeholder="请输入地址" clear width="180px" v-model="searcheForm.name"></el-input> -->
        </el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="search"
          >搜索</el-button
        >

        &nbsp;&nbsp;

        <el-button icon="el-icon-search" type="primary" @click="clearForm"
          >清除</el-button
        >
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button type="primary" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>

    <el-row>
      <div id="chart1" style="width: 100%; height: 500px"></div>
    </el-row>

    <!-- 表格 start -->
    <div style="margin-top: 30px">
      <el-table
        :data="items"
        stripe
        border
        v-loading="loading"
        element-loading-text="正在加载..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- <el-table-column
          type="selection"
          align="center"
          width="44"
        ></el-table-column> -->
        <el-table-column
          prop="statisticalDate"
          label="日期"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="totalOrders"
          label="订单总数"
          width="150"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="totalUsers"
          label="用户数"
          width="150"
          align="center"
          fixed="left"
        ></el-table-column>

        <el-table-column
          prop="totalMoney"
          label="累计收入（元）"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>
         <el-table-column
          prop="totalRefundFee"
          label="累计退费(元)"
          width="120"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="totalMinutes"
          label="累计充电时长（分）"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="totalQuantity"
          label="累计充电电量（瓦分）"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>

        <el-table-column
          prop="totalPower"
          label="累计充电时长（度）"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="orderAvgChargingTime"
          label="订单平均充电时长（分）"
          width="200"
          align="center"
          fixed="left"
        ></el-table-column>
        <!-- <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button @click="showStatisticalDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div style="display: flex; justify-content: flex-end">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          layout="sizes, prev, pager, next, jumper, ->, total, slot"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { postRequest } from "../../utils/api";
import { apiListStations } from "../charge/charge-equipment";
import {
  apiStatistical,
  apiStatisticalReportDailyData,
  apiStatisticalExport,
} from "./api";
export default {
  name: "StatisticalView",
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      headerTitel: "日统计报表",
      stationIdOptions: [],
      todayTotalMoney: 999.0,
      monthTotalMoney: 29999.88,
      items: [],
      searchForm: {
        stationId: null,
		page:1,
		size:1000
      },
      reportData1: {
        today: {
          totalMinutes: null,
          totalQuantity: null,
          totalMoney: null,
        },
        yesterday: {
          totalMinutes: null,
          totalQuantity: null,
          totalMoney: null,
        },
        lastMonth: {
          totalMinutes: null,
          totalQuantity: null,
          totalMoney: null,
        },
        currentMonth: {
          totalMinutes: null,
          totalQuantity: null,
          totalMoney: null,
        },
      },
    };
  },
  created() {
    this.initSelectStations();
    this.reportData();
  },
  methods: {
    handleExport() {
      postRequest("/api/charge-statistics/report-daily-export", this.searchForm).then(
        (resp) => {
          console.log("导出============" + resp.status);
		  if(resp.status==200){
			  let filename = resp.data.filename;
			  document.location.href="http://shhp.city/upload/download/"+filename;
		  }
        }
      );
    },
    sizeChange(currentSize) {
      this.size = currentSize;
      this.searchData();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.searchData();
    },
    showStatisticalDetail(row) {},
    reportData() {
      apiStatisticalReportDailyData({ page: this.page, size: this.size }).then(
        (resp) => {
          this.items = resp.data.list;
          this.drawLine(this.items);
          this.total = resp.data.total;
        }
      );
    },
    search() {
      this.searchData();
    },
    searchData() {
      this.searchForm.page = this.page;
      this.searchForm.size = this.size;
      apiStatisticalReportDailyData(this.searchForm).then((resp) => {
        this.items = resp.data.list;
        this.drawLine(this.items);
        this.total = resp.data.total;
      });
    },
    clearForm() {
      this.searchForm = {};
    },
    initSelectStations() {
      apiListStations(this.searchForm).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.stationList.forEach((element) => {
            this.stationIdOptions.push({
              label: element.stationName,
              value: element.id,
            });
          });
        }
      });
    },
    stationIdChange(v) {
      console.log("U Selected " + v);
    },
    drawLine(data) {
      // let data = resp.data.list;
      let _chart1 = this.$echarts.init(document.getElementById("chart1"));
      let xAxisData = new Array();
      let yOrders = new Array();
      let yMoney = new Array();
      let yTotalPower = new Array();
      let index = data.length - 1;
      data.forEach((e) => {
        xAxisData[index] = e.statisticalDate;
        yOrders[index] = e.totalOrders;
        yMoney[index] = e.totalMoney;
        yTotalPower[index] = e.totalPower;
        index--;
      });
      let option = {
        color: ['#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'],
        title: {
          text: "充电订单与充电电量、充电收入",
        },
        legend: {
          data: ["订单数", "充电电量", "充电收入"],
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "订单数",
            data: yOrders,
            type: "line",
          },
          {
            name: "充电电量",
            data: yTotalPower,
            type: "line",
          },
          {
            name: "充电收入",
            data: yMoney,
            type: "bar",
          },
        ],
      };
      _chart1.setOption(option);
    },
  },
};
</script>